import DefaultZohoSearch from "./ZohoSearch";

export default DefaultZohoSearch;
